import React, { useEffect, useMemo } from 'react';

import { meshModules } from 'Deer/constants/modules';
import { L3_PATHS } from 'Deer/constants/routes';
import { useRouteToNavLevels } from 'Deer/hooks/useRouteToL3';
import { IntentFilters } from 'Deer/intent/components/Layout/IntentFilters.layout';
import { IntentBreadcrumbType } from 'Deer/intent/types/IntentCommonTypes';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { INITIATIVE_INTENTS } from 'constants/moduleIntentTypes';

import { useInitiativeTypeValues } from '../hooks/useInitiativeTypeValues';
import { InitiativeDateRange, InitiativeIntentType, setSelectedInitiativeIntent } from '../slice/InitiativeIntentSlice';
import { MetaFilters } from './MetaFilters';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const IntentDropdown = ({
  initialDateRange,
  breadcrumbs,
}: {
  initialDateRange?: InitiativeDateRange;
  breadcrumbs: IntentBreadcrumbType;
}) => {
  const { l1Module } = useRouteToNavLevels();
  const history = useHistory();
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const initiativeTypes = useInitiativeTypeValues();

  // eslint-disable-next-line arrow-body-style
  const intentDropdownOptions = useMemo<Array<InitiativeIntentType>>(() => {
    return [
      {
        id: INITIATIVE_INTENTS.MY_INITIATIVES,
        label: 'My Initiatives',
        onClick: () => {
          const values = {
            myData: L3_PATHS['my-data'].initiative.myInitiatives,
          };
          const urlToPush = values[l1Module];

          history.push({
            pathname: urlToPush,
          });
        },
        visible: () => true,
        value: {
          myData: {
            path: L3_PATHS['my-data'].initiative.myInitiatives,
            isAccessible: () => true,
          },
        },
        initiativeTypes: initiativeTypes.filter((type) => type.enabled()),
        selectedInitiativeType: initiativeTypes[0],
        category: 'Manage',
        isDefault: true,
      },
    ];
  }, [initiativeTypes, l1Module, history]);

  const selectedIntent = useMemo(
    () => intentDropdownOptions.find((option) => pathname.includes(option.value[l1Module].path)),
    [intentDropdownOptions, pathname, l1Module]
  );

  useEffect(() => {
    dispatch(setSelectedInitiativeIntent(selectedIntent));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIntent, dispatch]);

  return (
    <IntentFilters
      intentDropdownOptions={intentDropdownOptions.filter((option) => option.visible())}
      selectedIntent={selectedIntent?.label ?? ''}
      selectedIntentId={selectedIntent?.id ?? ''}
      KebabMenu={null}
      MetaFilters={<MetaFilters initialDateRange={initialDateRange} />}
      showKebabMenu={false}
      moduleName={meshModules.initiatives.value}
      intentTitle={meshModules.initiatives.label}
      isCategorized
      breadcrumbs={breadcrumbs}
    />
  );
};

export { IntentDropdown };
